import { render, staticRenderFns } from "./product-carousel.vue?vue&type=template&id=1b0292be&scoped=true&lang=pug&"
import script from "./product-carousel.vue?vue&type=script&lang=coffee&"
export * from "./product-carousel.vue?vue&type=script&lang=coffee&"
import style0 from "./product-carousel.vue?vue&type=style&index=0&id=1b0292be&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0292be",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SsrCarousel: require('/opt/build/repo/node_modules/vue-ssr-carousel/index.js').default})
